import { createFeatureSelector, createSelector } from '@ngrx/store';
import { handleActions } from 'redux-actions';
import { ActionsEnum, SetDeviceId } from './browser-manager-data.actions';

// feature name
export const FEATURE_NAME = 'browser-manager-data';

// state definition
export interface IState {
  deviceId: string;
  online: boolean;
  tabVisible: boolean;
}

// initial state
export const initialState: IState = {
  deviceId: null,
  online: true,
  tabVisible: true,
};

// reducer
const reducerFn = handleActions(
  {
    [ActionsEnum.SET_DEVICE_ID]: function (
      state: IState,
      { payload }: SetDeviceId
    ): IState {
      return {
        ...state,
        deviceId: payload.deviceId,
      };
    },
    [ActionsEnum.ONLINE]: function (state: IState): IState {
      return {
        ...state,
        online: true,
      };
    },
    [ActionsEnum.OFFLINE]: function (state: IState): IState {
      return {
        ...state,
        online: false,
      };
    },
    [ActionsEnum.TAB_VISIBLE]: function (state: IState): IState {
      return {
        ...state,
        tabVisible: true,
      };
    },
    [ActionsEnum.TAB_HIDDEN]: function (state: IState): IState {
      return {
        ...state,
        tabVisible: false,
      };
    },
  } as any,
  initialState
);

// required for AOT
export function reducer(state: IState = initialState, action: any) {
  return reducerFn(state, action);
}

// selectors
const selectFeature = createFeatureSelector<IState>(FEATURE_NAME);

export const getDeviceId = createSelector(
  selectFeature,
  (state: IState) => state.deviceId
);
